import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTheme } from '@rneui/themed';
import { STD_UNIT_DAY, STD_UNIT_WEEK } from '../../hooks/useFirestore';

const ProgressTable = ({ total }) => {
  const { theme } = useTheme();

  const styles = StyleSheet.create({
    tableTextView: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    tableText: {
      marginBottom: 10,
      fontSize: 18,
      color: theme.colors.primary,
    },
  });

  //console.log('!!! total', total);

  const dailyValues = Object.values(total.daily);
  const numDays = dailyValues.length;
  const daysUnderLimit = dailyValues.reduce(
    (count, value) => (value < STD_UNIT_DAY ? count + 1 : count),
    0
  );

  const weeklyValues = Object.values(total.weekly);
  const numWeeks = weeklyValues.length;
  const weeksUnderLimit = weeklyValues.reduce(
    (count, value) => (value < STD_UNIT_WEEK ? count + 1 : count),
    0
  );

  return (
    <>
      <View style={styles.tableTextView}>
        <Text style={styles.tableText}>Dagar jag glömt</Text>
        <Text style={styles.tableText}>{total.forgotten}</Text>
      </View>
      {numWeeks && (
        <View style={styles.tableTextView}>
          <Text style={styles.tableText}>Veckor under gräns</Text>
          <Text style={styles.tableText}>
            {Math.round((weeksUnderLimit * 100) / numWeeks)}%
          </Text>
        </View>
      )}
      {numDays && (
        <View style={styles.tableTextView}>
          <Text style={styles.tableText}>Dagar under gräns</Text>
          <Text style={styles.tableText}>
            {Math.round((daysUnderLimit * 100) / numDays)}%
          </Text>
        </View>
      )}
      <View style={styles.tableTextView}>
        <Text style={styles.tableText}>Nolldagar</Text>
        <Text style={styles.tableText}>
          {Math.round((total.zero * 100.0) / Object.keys(total.daily).length)}%
        </Text>
      </View>
    </>
  );
};

export default ProgressTable;
